import type { IErrorEvent } from '@/modules/Core/errores/IErrorEvent'
import { BaseService } from '@/modules/Core/services/BaseService'

/**
 * Envio de errores del frontend al backend propio
 * (POST /api/v1/monitoring/frontend-errors/create).
 *
 * Desde ahi el backend los emite a stdout y Promtail los lleva a Loki/Grafana,
 * el mismo stack de monitoreo del clúster. No se usa ningun servicio externo.
 */
export class LogFrontendService extends BaseService<IErrorEvent> {
  constructor () {
    super({
      baseUrl: 'monitoring/frontend-errors/'
    })
  }

  /**
   * Fire-and-forget. A proposito NO usa `errorHandle`: si el reporte falla no
   * debe notificar al usuario, ni redirigir al login, ni relanzar, porque eso
   * generaria un bucle (error -> reporte -> error -> reporte...).
   */
  async registrar (evento: IErrorEvent): Promise<void> {
    try {
      await this.http.post('/create', evento)
    } catch {
      /* silencio deliberado */
    }
  }
}
